import { getApiEndpoint } from './config.js';
import { checkLogin, checkToken } from './account.js';

/**
 * Get standard texts.
 *
 * @param {object} token - The token to use, for getting standard texts.
 * @param {object} history - The history, for redirecting when user is not logged
 * in
 * @param {function} callback - The callback to trigger, after getting
 * standard texts.
 */
export function getStandardTexts(userId, token, history, callback) {
  if (!checkToken(token, history)) {
    return;
  }

  fetch(getApiEndpoint() + '/users/' + userId + '/standard-texts', {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      'X-Session-Id': token.id,
    },
  }).then(function(response) {
    checkLogin(response, history, callback);
  });
}

/**
 * Save a field for a standard text.
 *
 * @param {int} userId - The id of the user, that owns the standard text.
 * @param {int} standardTextId - The id of the standard text.
 * @param {string} field - The key for the field.
 * @param {string} value - The value to save.
 * @param {object} token - The token to use, for saving standard text.
 * @param {object} history - The history, for redirecting when user is not logged
 * in
 * @param {function} callback - The callback to trigger, after getting
 * saving standard text.
 */
export function saveStandardText(userId, standardTextId, field, value, token, history, callback) {
  if (!checkToken(token, history)) {
    return;
  }

  var modifier = {};
  modifier[field] = value;
  fetch(getApiEndpoint() + '/users/' + userId + '/standard-texts/' + standardTextId, {
    method: 'PATCH',
    headers: {
      'Content-Type': 'application/json',
      'X-Session-Id': token.id,
    },
    body: JSON.stringify([{
      op: 'set',
      fields: modifier,
    }]),
  }).then(function(response) {
    checkLogin(response, history, callback);
  });
}

/**
 * Create a standard text.
 *
 * @param {int} userId - The id of the user, that owns the standard text.
 * @param {object} standardText - The standard text to save.
 * @param {object} token - The token to use, for saving standard text.
 * @param {object} history - The history, for redirecting when user is not logged
 * in
 * @param {function} callback - The callback to trigger, after getting
 * saving standard text.
 */
export function createStandardText(userId, standardText, token, history, callback) {
  if (!checkToken(token, history)) {
    return;
  }

  fetch(getApiEndpoint() + '/users/' + userId + '/standard-texts', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-Session-Id': token.id,
    },
    body: JSON.stringify(standardText),
  }).then(function(response) {
    checkLogin(response, history, callback);
  });
}

/**
 * Delete a standard text.
 *
 * @param {int} userId - The id of the user, that owns the standard text.
 * @param {int} standardTextId - The id of the standard text to delete.
 * @param {object} token - The token to use, for delete standard text.
 * @param {object} history - The history, for redirecting when user is not logged
 * in
 * @param {function} callback - The callback to trigger, after deleting standard text.
 */
export function deleteStandardText(userId, standardTextId, token, history, callback) {
  if (!checkToken(token, history)) {
    return;
  }

  fetch(getApiEndpoint() + '/users/' + userId + '/standard-texts/' + standardTextId, {
    method: 'DELETE',
    headers: {
      'Content-Type': 'application/json',
      'X-Session-Id': token.id,
    },
  }).then(function(response) {
    checkLogin(response, history, callback);
  });
}



// WEBPACK FOOTER //
// ./src/utility/standardText.js